import React from 'react'

import { MachineType } from '@/services/model/machine';
import { BodyParams, FieldProps, FormDataBase, FormWrapper, onSubmit } from '@/components/forms/common/FormBase';
import { SubmitHandler } from 'react-hook-form';
import { codeTextField, datePickerField, imeiField, numberField, numericField, textField } from '@/components/forms/common/fields';

export interface Machine {
    id?: string
    imei?: string
    serialNumber?: string
    machineTypeId?: string
    internalNumber?: string
    nextUdtInspectionDate?: string
    udtExpirationDate?: string
    inspectionExpirationDate?: string
    machineType?: MachineType
}

export interface FormData extends Machine, FormDataBase {}

export interface FormParams extends BodyParams<FormData> {
  onSubmit: onSubmit<FormData>
}

export const QuickCreateMachineBody = (params: BodyParams<FormData>) => {
  const fieldProps: FieldProps<FormData> = {
    ...params,
    fieldName: ''
  }
  return <>
    {imei(fieldProps)}
    {serialNumber(fieldProps)}
    {manufactureDate(fieldProps)}
    {internalNumber(fieldProps)}
    {udtExpiration(fieldProps)}
    {inspectionExpirationDate(fieldProps)}
    {mthExpiration(fieldProps)}
  </>
}

export const QuickCreateMachineForm = (params: FormParams) => {
  const formHandler: SubmitHandler<FormData> = (data) => {
    params.onSubmit(data);
  }
  return <FormWrapper<FormData> className='main-form main-form-two-col' {...params} formName='machine' onSubmit={formHandler} hideSubmitBtn={true}>
    <QuickCreateMachineBody {...params} />
  </FormWrapper>
}

const imei = (props: FieldProps<FormData>) => imeiField<FormData>()({ ...props, fieldName: props.fieldName || 'imei', formName: props.formName || 'machine' })
const internalNumber = (props: FieldProps<FormData>) => textField<FormData>()({ ...props, fieldName: props.fieldName || 'internalNumber', formName: props.formName || 'machine' })
const udtExpiration = (props: FieldProps<FormData>) => datePickerField<FormData>()({ ...props, fieldName: props.fieldName || 'udtExpirationDate', formName: props.formName || 'machine' })
const inspectionExpirationDate = (props: FieldProps<FormData>) => datePickerField<FormData>()({ ...props, fieldName: props.fieldName || 'inspectionExpirationDate', formName: props.formName || 'machine' })
const mthExpiration = (props: FieldProps<FormData>) => numericField<FormData>()({ ...props, fieldName: props.fieldName || 'mthExpiration', formName: props.formName || 'machine' })
const serialNumber = (props: FieldProps<FormData>) => codeTextField<FormData>()({ ...props, fieldName: props.fieldName || 'serialNumber', formName: props.formName || 'machine' })
const manufactureDate = (props: FieldProps<FormData>) => numberField<FormData>()({ ...props, fieldName: props.fieldName || 'manufactureDate', formName: props.formName || 'machine' })